import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, costFormater, Image, NullIcon, Text, useResponsive } from '@common-fe/common-fe';
import _ from 'lodash';

import { FundPayload } from '../../SelfDirected.types';

interface Props extends FundPayload {
  investedAmount: number;
  percents: number;
  testId?: string;
}
const ConfirmModalItem: React.FC<Props> = ({
  title,
  stockCode,
  price = 0,
  investedAmount,
  logo,
  percents,
  testId,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();
  const currentMoneyAmount = useMemo(() => {
    return investedAmount * (percents / 100);
  }, [investedAmount, percents]);

  const currentAmount = useMemo(() => {
    return _.floor(currentMoneyAmount / price, 3);
  }, [currentMoneyAmount, price]);

  if (isMobile) {
    return (
      <Box
        direction="column"
        pad="spacing12"
        background="canvas"
        round="container2Round"
        border={{ size: 'small', color: 'border1' }}
      >
        <Box direction="row" align="center">
          <div>
            <Box>
              {logo ? (
                <Image width="32px" height="32px" data-testid="fund_item-logo" src={logo} />
              ) : (
                <NullIcon color="iconPrimary" size="32px" />
              )}
            </Box>
          </div>
          <Box direction="column" margin={{ left: 'spacing12' }}>
            <Text data-testId={`${testId}_title`} title={title} tip={title} truncate weight={700}>
              {title}
            </Text>
            <Text>{stockCode}</Text>
          </Box>
        </Box>

        <Box height="1px" background="border1" margin={{ vertical: 'spacing12' }} />

        <Box direction="row" align="center" justify="between">
          <Text size="small" weight={700} data-testId={`${testId}_label_current-money-amount`}>
            {t('Amount')}
          </Text>
          <Text color="success" data-testId={`${testId}_current-money-amount`} weight={700}>
            {costFormater(currentMoneyAmount, {
              isPrecision: true,
            })}
          </Text>
        </Box>

        <Box direction="row" align="center" justify="between">
          <Text size="small" weight={700} data-testId={`${testId}_label_price`}>
            {t('Share price')}
          </Text>
          <Text size="medium" weight={400} data-testId={`${testId}_price`}>
            {costFormater(price, { isPrecision: true })}
          </Text>
        </Box>

        <Box direction="row" align="center" justify="between">
          <Text size="small" weight={700} data-testId={`${testId}_label_amount`}>
            {t('You receive')}
          </Text>
          <Text size="medium" weight={400} data-testId={`${testId}_amount`}>
            {currentAmount}
          </Text>
        </Box>

        <Box direction="row" align="center" justify="between">
          <Text size="small" weight={700} data-testId={`${testId}_label_amount`}>
            {t('Election')}
          </Text>
          <Text size="medium" weight={400} data-testId={`${testId}_percents`}>
            {percents}%
          </Text>
        </Box>
      </Box>
    );
  }
  return (
    <Box
      direction="row"
      pad={{ vertical: 'spacing12', horizontal: 'spacing24' }}
      background="canvas"
      align="center"
      round="container2Round"
      border={{ size: 'small', color: 'border1' }}
    >
      <Box>
        {logo ? (
          <Image width="32px" height="32px" data-testid="fund_item-logo" src={logo} />
        ) : (
          <NullIcon color="iconPrimary" size="32px" />
        )}
      </Box>
      <Box
        margin={{ left: 's' }}
        style={{
          flex: 2,
          position: 'relative',
        }}
        direction="column"
      >
        <Box width="100%">
          <Text data-testId={`${testId}_title`} tip={title} truncate weight={700}>
            {title}
          </Text>
          <Text>{stockCode}</Text>
        </Box>
      </Box>
      <Box width={{ min: '80px' }} margin={{ left: 's' }}>
        <Text data-testId={`${testId}_price`}>{costFormater(price, { isPrecision: true })}</Text>
      </Box>
      <Box width={{ min: '80px' }} margin={{ left: 's' }}>
        <Text data-testId={`${testId}_amount`}>{currentAmount}</Text>
      </Box>
      <Box width={{ min: '80px' }} margin={{ left: 's' }}>
        <Text color="success" data-testId={`${testId}_current-money-amount`} weight={700}>
          {costFormater(currentMoneyAmount, {
            isPrecision: true,
          })}
        </Text>
      </Box>
      <Box width={{ min: '80px' }} margin={{ left: 's' }}>
        <Text data-testId={`${testId}_percents`}>{percents}%</Text>
      </Box>
    </Box>
  );
};

export default ConfirmModalItem;
